import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HolidayMasterComponent } from './holiday-master/holiday-master.component';

const routes: Routes = [{ path: 'holiday', component: HolidayMasterComponent },];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ParameterMasterRoutingModule {

}
